module.exports = __webpack_public_path__ + "static/media/flowers_10.2ab6f6b9.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/flowers/flowers_10.csv
// module id = 749
// module chunks = 0